/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_Permissions
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

export const CALENDAR_VIEW_REPORTS = 'Calendar_View_Reports' as const;
export const CENTER_SIGN_IN_MANAGE = 'CenterSignIn_Manage' as const;
export const CONTROL_EXAMS = 'Control_Exams' as const;
export const COURSE_LIST_PARTICIPANT_VIEW = 'Course_List_Participant_View' as const;
export const COURSE_MONITOR_EXAM_SESSIONS = 'Course_Monitor_ExamSessions' as const;
export const COURSE_PARTICIPANT_MANAGE = 'Course_Participant_Manage' as const;
export const COURSE_PARTICIPANT_MANAGE_VIEW = 'Course_Participant_Manage_View' as const;
export const COURSE_PARTICIPANT_RESULT_VIEW = 'Course_Participant_Result_View' as const;
export const COURSE_PRIVATE_VIEW = 'Course_Private_View' as const;
export const COURSE_STATISTICS_REPORT_VIEW = 'Course_Statistics_Report_View' as const;
export const COURSE_TOTAL_GRADES_VIEW = 'Course_Total_Grades_View' as const;
export const COURSES_AGENDA_MANAGE = 'Courses_Agenda_Manage' as const;
export const COURSES_AGENDA_VIEW = 'Courses_Agenda_View' as const;
export const COURSES_ARCHIVE = 'Courses_Archive' as const;
export const COURSES_CREATE = 'Courses_Create' as const;
export const COURSES_CURRICULUM_MANAGE = 'Courses_Curriculum_Manage' as const;
export const COURSES_EDIT = 'Courses_Edit' as const;
export const COURSES_EXPORT = 'Courses_Export' as const;
export const COURSES_IMPORT = 'Courses_Import' as const;
export const COURSES_LIST_VIEW = 'CoursesList_View' as const;
export const COURSES_PEOPLE_CHANGE_CONTRIBUTORS = 'Courses_People_ChangeContributors' as const;
export const COURSES_PEOPLE_CHANGE_MONITORS = 'Courses_People_ChangeMonitors' as const;
export const COURSES_PEOPLE_CHANGE_OWNER = 'Courses_People_ChangeOwner' as const;
export const COURSES_PEOPLE_CHANGE_VIEWERS = 'Courses_People_ChangeViewers' as const;
export const COURSES_RESULTS_MANAGE = 'Courses_Results_Manage' as const;
export const COURSES_RESULTS_VIEW = 'Courses_Results_View' as const;
export const COURSES_VIEW = 'Courses_View' as const;
export const DASHBOARD_INSIGHTS_VIEW = 'DashboardInsights_View' as const;
export const DASHBOARD_REPORTS_VIEW = 'DashboardReports_View' as const;
export const EVALUATION_COMPLETE = 'Evaluation_Complete' as const;
export const EVALUATION_CREATE = 'Evaluation_Create' as const;
export const EVALUATION_EDIT = 'Evaluation_Edit' as const;
export const EVALUATION_GRADES_VIEW = 'Evaluation_Grades_View' as const;
export const EVALUATION_TEMPLATE_FILL_VIEW = 'EvaluationTemplate_Fill_View' as const;
export const EVALUATION_VIEW = 'Evaluation_View' as const;
export const EXAM_EVALUATION_LIST = 'Exam_Evaluation_List' as const;
export const HELP_ADMIN_VIEW = 'HelpAdmin_View' as const;
export const MONITOR_EXAM_SESSIONS = 'Monitor_ExamSessions' as const;
export const ORGANIZATION_VIEW = 'Organization_View' as const;
export const PARTICIPANTS_CHANGE_PASSWORD = 'Participants_ChangePassword' as const;
export const PARTICIPANTS_CREATE = 'Participants_Create' as const;
export const PARTICIPANTS_EDIT = 'Participants_Edit' as const;
export const PARTICIPANTS_IMPORT = 'Participants_Import' as const;
export const PROFILE_CONTACT_EDIT = 'ProfileContact_Edit' as const;
export const REPORT_COURSE_VIEW = 'Report_Course_View' as const;
export const REPORTS_ANNOTATION_VIEW = 'ReportsAnnotation_View' as const;
export const REPORTS_ORGANIZATION_VIEW = 'Reports_Organization_View' as const;
export const REPORTS_REPORT_ON_ANSWER_GRADES = 'Reports_ReportOn_AnswerGrades' as const;
export const REPORTS_REPORT_ON_SESSION_ANNOTATIONS = 'Reports_ReportOn_SessionAnnotations' as const;
export const REPORTS_REPORT_ON_SESSIONS = 'Reports_ReportOn_Sessions' as const;
export const REPORTS_SCENARIO_VIEW = 'Reports_Scenario_View' as const;
export const REPORTS_SESSIONS_VIEW = 'Reports_Sessions_View' as const;
export const REPORTS_USAGE_VIEW = 'ReportsUsage_View' as const;
export const RESERVATION_REQUESTS_DELETE = 'Reservation_Requests_Delete' as const;
export const RESERVATION_REQUESTS_LIST = 'Reservation_Requests_List' as const;
export const RESERVATION_REQUESTS_VIEW = 'Reservation_Requests_View' as const;
export const RESERVATIONS_CREATE = 'Reservations_Create' as const;
export const RESERVATIONS_EDIT = 'Reservations_Edit' as const;
export const RESERVATIONS_LIST = 'Reservations_List' as const;
export const RESERVATIONS_PRIVATE_VIEW = 'Reservations_Private_View' as const;
export const RESERVATIONS_REQUEST = 'Reservations_Request' as const;
export const RESERVATIONS_VIEW = 'Reservations_View' as const;
export const SCENARIO_EVALUATION_RESULTS_VIEW = 'Scenario_Evaluation_Results_View' as const;
export const SCENARIO_EVALUATION_TEMPLATE_MANAGE = 'Scenario_Evaluation_Template_Manage' as const;
export const SCENARIO_PRIVATE_VIEW = 'Scenario_Private_View' as const;
export const SCENARIOS_ANNOTATIONS_EDIT = 'ScenariosAnnotations_Edit' as const;
export const SCENARIOS_ARCHIVE = 'Scenarios_Archive' as const;
export const SCENARIOS_ATTACHMENTS_UPLOAD = 'ScenariosAttachments_Upload' as const;
export const SCENARIOS_CREATE = 'Scenarios_Create' as const;
export const SCENARIOS_EDIT = 'Scenarios_Edit' as const;
export const SCENARIOS_EXPORT = 'Scenarios_Export' as const;
export const SCENARIOS_IMPORT = 'Scenarios_Import' as const;
export const SCENARIOS_LIST_VIEW = 'ScenariosList_View' as const;
export const SCENARIOS_PEOPLE_CHANGE_CONTRIBUTOR = 'ScenariosPeople_ChangeContributor' as const;
export const SCENARIOS_PEOPLE_CHANGE_OWNER = 'ScenariosPeople_ChangeOwner' as const;
export const SCENARIOS_PEOPLE_CHANGE_VIEWERS = 'ScenariosPeople_ChangeViewers' as const;
export const SCENARIOS_VIEW = 'Scenarios_View' as const;
export const SCORING_EVALUATION_COMPLETE = 'Scoring_Evaluation_Complete' as const;
export const SCORING_EVALUATION_CREATE = 'Scoring_Evaluation_Create' as const;
export const SCORING_EVALUATION_EDIT = 'Scoring_Evaluation_Edit' as const;
export const SCORING_EVALUATION_VIEW = 'Scoring_Evaluation_View' as const;
export const SCORING_RUBRIC_FILL_VIEW = 'Scoring_Rubric_Fill_View' as const;
export const SESSION_JOIN_LIVE = 'Session_JoinLive' as const;
export const SESSION_LINK_MANAGE = 'Session_Link_Manage' as const;
export const SESSION_LIST_LIVE = 'Session_List_Live' as const;
export const SESSION_PTZ_MANAGE = 'Session_Ptz_Manage' as const;
export const SESSION_START_COURSE = 'Session_Start_Course' as const;
export const SESSION_START_SCENARIO = 'Session_Start_Scenario' as const;
export const SESSION_STOP = 'Session_Stop' as const;
export const SESSIONS_ADMIN_EVALUATIONS_CREATE = 'Sessions_Admin_Evaluations_Create' as const;
export const SESSIONS_CREATE = 'Sessions_Create' as const;
export const SESSIONS_DELETE = 'Sessions_Delete' as const;
export const SESSIONS_DOWNLOAD = 'Sessions_Download' as const;
export const SESSIONS_EVALUATION_LIST = 'Sessions_Evaluation_List' as const;
export const SESSIONS_EVALUATION_RESULTS_VIEW = 'Sessions_Evaluation_Results_View' as const;
export const SESSIONS_IMPORT = 'Sessions_Import' as const;
export const SESSIONS_LIST_VIEW = 'SessionsList_View' as const;
export const SESSIONS_VIEW = 'Sessions_View' as const;
export const SPS_CREATE = 'Sps_Create' as const;
export const SPS_DESIGNATE = 'Sps_Designate' as const;
export const SPS_EDIT_DEMOGRAPHICS = 'Sps_Edit_Demographics' as const;
export const SPS_IMPORT = 'Sps_Import' as const;
export const SPS_VIEW_DEMOGRAPHICS = 'Sps_View_Demographics' as const;
export const SV_PEOPLE_CHANGE_CONTRIBUTOR = 'SV_People_ChangeContributor' as const;
export const SV_PEOPLE_CHANGE_OWNER = 'SV_People_ChangeOwner' as const;
export const SV_PEOPLE_CHANGE_PARTICIPANT = 'SV_People_ChangeParticipant' as const;
export const SV_PEOPLE_CHANGE_PATIENT = 'SV_People_ChangePatient' as const;
export const SV_PEOPLE_CHANGE_VIEWERS = 'SV_People_ChangeViewers' as const;
export const SV_PEOPLE_CREATE_EXTERNAL_LINK = 'SV_People_CreateExternalLink' as const;
export const SV_PEOPLE_VIEW = 'SV_People_View' as const;
export const SV_RECORDING_ANNOTATIONS_CREATE = 'SV_RecordingAnnotations_Create' as const;
export const SV_RECORDING_ANNOTATIONS_EDIT = 'SV_RecordingAnnotations_Edit' as const;
export const SV_RECORDING_ANNOTATIONS_LIST = 'SV_RecordingAnnotations_List' as const;
export const SV_RECORDING_ANNOTATIONS_VIEW = 'SV_RecordingAnnotations_View' as const;
export const SV_SIM_DATA_IMPORT = 'SV_SimData_Import' as const;
export const SV_SUMMARY_EDIT = 'SV_Summary_Edit' as const;
export const SYSTEM_SETUP_VIEW = 'SystemSetup_View' as const;
export const USER_ROLE_VIEW = 'UserRole_View' as const;
export const USERS_CHANGE_PASSWORD = 'Users_ChangePassword' as const;
export const USERS_CHANGE_ROLE = 'Users_ChangeRole' as const;
export const USERS_CREATE = 'Users_Create' as const;
export const USERS_EDIT = 'Users_Edit' as const;
export const USERS_EXPORT = 'Users_Export' as const;
export const USERS_IMPORT = 'Users_Import' as const;
export const USERS_LIST_VIEW = 'UsersList_View' as const;
export const USERS_SETTINGS_EDIT = 'UsersSettings_Edit' as const;
export const USERS_VIEW = 'Users_View' as const;

const LU_Permissions = {
    CALENDAR_VIEW_REPORTS,
    CENTER_SIGN_IN_MANAGE,
    CONTROL_EXAMS,
    COURSE_LIST_PARTICIPANT_VIEW,
    COURSE_MONITOR_EXAM_SESSIONS,
    COURSE_PARTICIPANT_MANAGE,
    COURSE_PARTICIPANT_MANAGE_VIEW,
    COURSE_PARTICIPANT_RESULT_VIEW,
    COURSE_PRIVATE_VIEW,
    COURSE_STATISTICS_REPORT_VIEW,
    COURSE_TOTAL_GRADES_VIEW,
    COURSES_AGENDA_MANAGE,
    COURSES_AGENDA_VIEW,
    COURSES_ARCHIVE,
    COURSES_CREATE,
    COURSES_CURRICULUM_MANAGE,
    COURSES_EDIT,
    COURSES_EXPORT,
    COURSES_IMPORT,
    COURSES_LIST_VIEW,
    COURSES_PEOPLE_CHANGE_CONTRIBUTORS,
    COURSES_PEOPLE_CHANGE_MONITORS,
    COURSES_PEOPLE_CHANGE_OWNER,
    COURSES_PEOPLE_CHANGE_VIEWERS,
    COURSES_RESULTS_MANAGE,
    COURSES_RESULTS_VIEW,
    COURSES_VIEW,
    DASHBOARD_INSIGHTS_VIEW,
    DASHBOARD_REPORTS_VIEW,
    EVALUATION_COMPLETE,
    EVALUATION_CREATE,
    EVALUATION_EDIT,
    EVALUATION_GRADES_VIEW,
    EVALUATION_TEMPLATE_FILL_VIEW,
    EVALUATION_VIEW,
    EXAM_EVALUATION_LIST,
    HELP_ADMIN_VIEW,
    MONITOR_EXAM_SESSIONS,
    ORGANIZATION_VIEW,
    PARTICIPANTS_CHANGE_PASSWORD,
    PARTICIPANTS_CREATE,
    PARTICIPANTS_EDIT,
    PARTICIPANTS_IMPORT,
    PROFILE_CONTACT_EDIT,
    REPORT_COURSE_VIEW,
    REPORTS_ANNOTATION_VIEW,
    REPORTS_ORGANIZATION_VIEW,
    REPORTS_REPORT_ON_ANSWER_GRADES,
    REPORTS_REPORT_ON_SESSION_ANNOTATIONS,
    REPORTS_REPORT_ON_SESSIONS,
    REPORTS_SCENARIO_VIEW,
    REPORTS_SESSIONS_VIEW,
    REPORTS_USAGE_VIEW,
    RESERVATION_REQUESTS_DELETE,
    RESERVATION_REQUESTS_LIST,
    RESERVATION_REQUESTS_VIEW,
    RESERVATIONS_CREATE,
    RESERVATIONS_EDIT,
    RESERVATIONS_LIST,
    RESERVATIONS_PRIVATE_VIEW,
    RESERVATIONS_REQUEST,
    RESERVATIONS_VIEW,
    SCENARIO_EVALUATION_RESULTS_VIEW,
    SCENARIO_EVALUATION_TEMPLATE_MANAGE,
    SCENARIO_PRIVATE_VIEW,
    SCENARIOS_ANNOTATIONS_EDIT,
    SCENARIOS_ARCHIVE,
    SCENARIOS_ATTACHMENTS_UPLOAD,
    SCENARIOS_CREATE,
    SCENARIOS_EDIT,
    SCENARIOS_EXPORT,
    SCENARIOS_IMPORT,
    SCENARIOS_LIST_VIEW,
    SCENARIOS_PEOPLE_CHANGE_CONTRIBUTOR,
    SCENARIOS_PEOPLE_CHANGE_OWNER,
    SCENARIOS_PEOPLE_CHANGE_VIEWERS,
    SCENARIOS_VIEW,
    SCORING_EVALUATION_COMPLETE,
    SCORING_EVALUATION_CREATE,
    SCORING_EVALUATION_EDIT,
    SCORING_EVALUATION_VIEW,
    SCORING_RUBRIC_FILL_VIEW,
    SESSION_JOIN_LIVE,
    SESSION_LINK_MANAGE,
    SESSION_LIST_LIVE,
    SESSION_PTZ_MANAGE,
    SESSION_START_COURSE,
    SESSION_START_SCENARIO,
    SESSION_STOP,
    SESSIONS_ADMIN_EVALUATIONS_CREATE,
    SESSIONS_CREATE,
    SESSIONS_DELETE,
    SESSIONS_DOWNLOAD,
    SESSIONS_EVALUATION_LIST,
    SESSIONS_EVALUATION_RESULTS_VIEW,
    SESSIONS_IMPORT,
    SESSIONS_LIST_VIEW,
    SESSIONS_VIEW,
    SPS_CREATE,
    SPS_DESIGNATE,
    SPS_EDIT_DEMOGRAPHICS,
    SPS_IMPORT,
    SPS_VIEW_DEMOGRAPHICS,
    SV_PEOPLE_CHANGE_CONTRIBUTOR,
    SV_PEOPLE_CHANGE_OWNER,
    SV_PEOPLE_CHANGE_PARTICIPANT,
    SV_PEOPLE_CHANGE_PATIENT,
    SV_PEOPLE_CHANGE_VIEWERS,
    SV_PEOPLE_CREATE_EXTERNAL_LINK,
    SV_PEOPLE_VIEW,
    SV_RECORDING_ANNOTATIONS_CREATE,
    SV_RECORDING_ANNOTATIONS_EDIT,
    SV_RECORDING_ANNOTATIONS_LIST,
    SV_RECORDING_ANNOTATIONS_VIEW,
    SV_SIM_DATA_IMPORT,
    SV_SUMMARY_EDIT,
    SYSTEM_SETUP_VIEW,
    USER_ROLE_VIEW,
    USERS_CHANGE_PASSWORD,
    USERS_CHANGE_ROLE,
    USERS_CREATE,
    USERS_EDIT,
    USERS_EXPORT,
    USERS_IMPORT,
    USERS_LIST_VIEW,
    USERS_SETTINGS_EDIT,
    USERS_VIEW
} as const;

export type Permission = typeof LU_Permissions[keyof typeof LU_Permissions];

export default LU_Permissions;
